import React from "react";
import PaxesBlock from "../../components/paxesBlock";
import {Col, Form, Row} from "react-bootstrap";
import { useFieldArray } from "react-hook-form";
import TripTransferForm from "../../components/tripTransfer";
import TripEtcForm from "../../components/tripEtc";
import UsersBlock from "../../trip/components/tripFormParts/usersBlock";

const EtcBlock = props => {
  const { formController, etc } = props;
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    control,
    getValues,
    reset
  } = formController;
  const paxArray = useFieldArray({
    control,
    name: `paxes`
  });
  return (
    <>
      <Row>
        <Col xs={12}>
          <UsersBlock
            prefix={"item.visibleToAccounts"}
            formController={formController}
            type={`trips/${etc.item.type}/`}
          />
          <PaxesBlock
            prefix={"paxes"}
            formController={formController}
            paxes={etc.paxes}
            paxArray={paxArray}
            hideButtons={true}
          />
          <Form.Label className={'d-flex align-items-center gap-2'}>
            <input
              defaultChecked={etc.item.public}
              {...register(`item.public`)}
              type={"checkbox"}
            />{" "}
            Публичный
          </Form.Label>
          <br />
          <TripEtcForm
            formController={formController}
            item={etc.item}
            prefix={"item"}
            withoutPaxes={true}
            activ
          />
        </Col>
      </Row>
    </>
  );
};

export default EtcBlock;
